import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { Page } from '@/interfaces/api/Page';
import Filter from '@/interfaces/api/Filter';
import { Pagination } from '@/interfaces/api/Pagination';
import { DepositRule } from '@/interfaces/models/DepositRule';

export default class DepositRuleApiService extends ApiService<DepositRule> {
  constructor() {
    super('general/deposit-rules', 'v1');
  }

  public fetch(page: Page, filter: Filter): AxiosPromise<Pagination<DepositRule | DepositRule[]>> {
    return axios.get(`${this.getBaseUrl()}/`, {
      params: { page: page.page, limit: 10, ...filter },
    });
  }

  public delete(param: { id: string }) {
    return axios.delete(`${this.getBaseUrl()}/${param.id}`);
  }
}
